<div class="flex flex-col sm:flex-row w-full justify-between items-start sm:items-center mb-8">
  <h1 class="font-bold mb-0 overflow-hidden whitespace-nowrap text-ellipsis w-full">{{ { key: 'placeBooking' } | i18n }}</h1>
  <div class="mt-4 sm:mt-0 flex-shrink-0">
    <a
      class="block items-center justify-center border border-transparent py-2 px-4 text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2"
      [routerLink]="['/places']"
    >
      {{ { key: 'createNewBooking' } | i18n }}
    </a>
  </div>
</div>

<div class="flex flex-col gap-4">
  @if (bookings.isLoading()) {
    <div class="flex justify-center items-center h-64">
      <app-loading [noWhitespace]="true"></app-loading>
    </div>
  } @else if (bookings.error()) {
    <div class="flex justify-center items-center h-64">
      <div class="text-red-500">{{ { key: 'errorLoading' } | i18n }}</div>
    </div>
  } @else {
    <div class="flex flex-row w-full justify-end mb-4"></div>
    <div class="flex flex-col gap-4">
      @for (booking of bookings.value(); track booking._id) {
        <div class="flex flex-row justify-between items-center hover:bg-opacity-10 hover:bg-primary-600 p-4 border border-primary-600">
          <div class="flex flex-col">
            <div class="font-bold mb-1">{{ booking.time }}</div>
            <div>{{ booking.place | i18n }}</div>
          </div>
          @if (isCancellationPossible(booking)) {
            <button
              class="inline-flex justify-center border border-transparent bg-primary-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-700 focus:ring-offset-2"
              (click)="openCancellationOverlay(booking)"
            >
              {{ { key: 'cancelBooking' } | i18n }}
            </button>
          } @else {
            <div class="text-gray-700">{{ { key: 'cancellationNotPossible' } | i18n }}</div>
          }
        </div>
      } @empty {
        <div class="text-gray-500">{{ { key: 'noEntries' } | i18n }}</div>
      }
    </div>
  }
</div>
